import * as yup from 'yup';
import TranslationHelper from '@/app/helpers/TranslationHelper';
import { FIELD_REQUIRED } from '@/app/constants/yup';

export const validationSchema = yup.object().shape({
    firstName: yup
        .string()
        .required(() => TranslationHelper.translate(FIELD_REQUIRED)),
    lastName: yup
        .string()
        .required(() => TranslationHelper.translate(FIELD_REQUIRED)),
    email: yup
        .string()
        .email(() => TranslationHelper.translate('E-mail is invalid'))
        .required(() => TranslationHelper.translate(FIELD_REQUIRED)),
});
